import { ElementsUsedByClient } from '@server/read-only-elements.consts';
import {
  Timer,
  Settings,
  Notification,
  Filter,
  Mail,
  Play,
  Automations,
  MathOperations,
  Cube,
  Assign,
  PlaybookAlert,
  Copy,
  Target,
  Hash,
  Path,
  Users,
  Clock,
} from '@sweep-io/sweep-design/dist/icons';
import { ReactNode } from 'react';
import {
  SWEEP_ASSIGNMENT,
  SWEEP_ALERT,
  SWEEP_AUTOMATION,
  SWEEP_DEDUPE,
  SWEEP_MATCHING,
  SWEEP_SCHEDULED_ASSIGNMENT,
} from '../../../../../../parser/ConfigurationItemTypes';

export const propertiesToIcon: { [key: string]: ReactNode } = {
  name: <Hash size="medium" />,
  trigger: <Play size="medium" />,
  conditions: <Path size="medium" />,
  delay: <Timer size="medium" />,
  actions: <Automations size="medium" />,
  settings: <Settings size="medium" />,
  notification: <Notification size="medium" />,
  calculation: <MathOperations size="medium" />,
  filter: <Filter size="medium" />,
  lookup_relations: <Filter size="medium" />,
  field: <Cube size="medium" />,
  [ElementsUsedByClient.ASSIGNMENT_ASSIGN_TO]: <Assign size="medium" />,
  [ElementsUsedByClient.SEND_SLACK_MESSAGE]: <Notification size="medium" />,
  [ElementsUsedByClient.MET_CONDITIONS]: <Path size="medium" />,
  [ElementsUsedByClient.ASSIGNMENT_DO_NOT_NOTIFY]: <Notification size="medium" />,
  [ElementsUsedByClient.SEND_EMAIL]: <Mail size="medium" />,
  [ElementsUsedByClient.ASSIGNMENT_RULES]: <Users size="medium" />,
  [ElementsUsedByClient.UPDATE_RECORDS]: <Automations size="medium" />,
  [ElementsUsedByClient.CREATE_RECORD]: <Automations size="medium" />,
};

export const configurationItemTypeToIcon = {
  [SWEEP_ASSIGNMENT]: <Assign size="medium" />,
  [SWEEP_ALERT]: <PlaybookAlert size="medium" />,
  [SWEEP_AUTOMATION]: <Automations size="medium" />,
  [SWEEP_DEDUPE]: <Copy size="medium" />,
  [SWEEP_MATCHING]: <Target size="medium" />,
  [SWEEP_SCHEDULED_ASSIGNMENT]: <Clock size="medium" />,
};
